<template>
    <div>
        <div
            :style="{ 'height': divHeight+'px','z-index': 199,'width':'1100px','position':'absolute','background-color':'black','opacity':0 }"/>

        <div id="formDiv" :key="key">
            <el-form v-if="type === '01'" ref="form" :model="form">
                <div v-for="(item,index) in infoData.allQuestion" style="text-align:left;">
                    <div :style="{ height:  40 + item.allOptions.length*60+ 'px' }">
                        <div
                            style="margin-left:50px; width:18px; display:inline-block; margin-top:30px; font-weight:bold; color:#FBF3CF; background-color:#FD7A7A; text-align:center;">
                            {{ index + 1 }}
                        </div>
                        <span>&nbsp;{{ item.questionContent }}</span>
                        <span>
                            <el-form-item style="margin-left:50px" :prop="'_01['+index+']'"
                                          :rules="[{required: true, message: '请选择答案'}]">
                                <div v-if="item.questionType === '01'" v-for="(question,i) in item.allOptions">
                                    <el-radio v-model="form._01[index]" :label="question.comboValue">
                                        {{ question.comboValue }}.{{ question.comboName }}
                                    </el-radio>
                                </div>

                                <div v-if="item.questionType === '05'" v-for="(question,i) in item.allOptions">
                                    <el-radio v-model="form._01[index]" :label="question.comboValue">
                                        {{ question.comboValue }}.{{ question.comboName }}分
                                    </el-radio>
                                </div>

                                <div v-if="item.questionType === '02'">
                                    <el-checkbox-group v-model="form._01[index]">
                                        <div v-for="(question,i) in item.allOptions">
                                            <el-checkbox :label="question.comboValue">{{
                                                    question.comboValue
                                                }}.{{ question.comboName }}</el-checkbox>
                                        </div>
                                    </el-checkbox-group>
                                </div>
                            </el-form-item>
                        </span>
                    </div>
                    <div v-if="index!==infoData.allQuestion.length-1" style="margin:0 auto; width: 1000px">
                        <el-divider/>
                    </div>
                </div>
            </el-form>

            <el-form v-if="type === '05'" ref="form" :model="form">
                <div id="mask" style="position:absolute; top:0; z-index:99999; background:url(0); display:none;"></div>
                <div style="width:100%; position:relative; left:8px;"><br/>
                    <div class="contentTitle" style="float:left; width:250px;">学生姓名：{{ infoData.basic.stuName }}</div>
                    <div class="contentTitle" style="float:left;">班级名称：{{ infoData.basic.className }}</div>
                </div>

                <div class="container">
                    <table class="contentTable" cellpadding="0" cellspacing="0">
                        <tr class="contentTr_3">
                            <td class="contentTd contentTitle" rowspan="2"
                                style="background-color: white;min-width:40px;position: sticky;top: 0;left: 0;z-index: 99;">
                                序号
                            </td>
                            <td class="contentTd contentTitle" rowspan="2"
                                style="background-color: white;min-width:260px;position: sticky;top: 0;left: 40px;z-index: 99;">
                                评价标准
                            </td>
                            <td class="contentTd contentTitle"
                                style="background-color: white;position: sticky;top: 0;z-index: 95;"
                                :colspan="infoData.teaInfo.length">教师姓名（课程）
                            </td>
                        </tr>

                        <tr style="background-color: white;position: sticky;top: 30px;z-index: 95;">
                            <td v-for="(item,index) in infoData.teaInfo" class="contentTd" style="min-width:200px;">
                                {{ item.teaName }}<br/>（{{ item.courseName }}）
                            </td>
                        </tr>

                        <tr v-for="(item,row) in infoData.allQuestion" class="contentTr_3">
                            <td style="background-color: white;min-width:40px;position: sticky;top: 0;left: 0;z-index: 98;"
                                class="contentTd">{{ row + 1 }}
                            </td>
                            <td style="background-color: white;min-width:260px;position: sticky;top: 0;left: 40px;z-index: 98;"
                                class="contentTd">
                                <div style="margin:0 2% 0 2%; text-align:left;">{{ item.questionContent }}</div>
                            </td>
                            <td v-for="(column,column) in infoData.teaInfo" class="contentTd"
                                style="position: sticky;height:75px;z-index: 0">
                                <el-form-item :prop="'_05['+row+']['+column+']'"
                                              :rules="[{required: true, message: ' '}]">
                                    <el-select v-if="item.questionType === '01'" v-model="form._05[row][column]"
                                               :disabled="flag" clearable>
                                        <el-option v-for="list in item.allOptions" :key="list.comboValue"
                                                   :label="list.comboName" :value="list.comboValue">
                                        </el-option>
                                    </el-select>

                                    <el-select v-if="item.questionType === '02'" multiple :disable="flag" v-model="form._05[row][column]"
                                               :disabled="flag" clearable>
                                        <el-option v-for="list in item.allOptions" :key="list.comboValue"
                                                   :label="list.comboName" :value="list.comboValue">
                                        </el-option>
                                    </el-select>

                                    <el-select v-if="item.questionType === '05'" v-model="form._05[row][column]"
                                               :disabled="flag" clearable>
                                        <el-option v-for="list in item.allOptions" :key="list.comboValue"
                                                   :label="list.comboValue" :value="list.comboValue">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import {
    confirmMsg,
    showNotify
} from "utils/message";

export default {
    props: ['infoData', 'userCode', 'doFlag', 'state'],
    data() {
        return {
            typeFlag: true,
            flag: false,
            type: '',
            form: {
                _01: [],
                _05: []
            },
            loadingMask: null,
            divHeight: '',
            key: 0,
        }
    },
    mounted() {
        this.type = this.infoData.basic.type;
        if (this.state === '3' || this.state === '4' || this.doFlag === '2') {
            this.flag = true;
        } else {
            this.flag = false;
        }

        if (this.type === '01') {
            if (this.doFlag === '0') {
                for (let i = 0; i < this.infoData.allQuestion.length; i++) {
                    if (this.infoData.allQuestion[i].questionType === '02') {
                        this.form._01.push([])
                    } else {
                        this.form._01.push('')
                    }
                }
            } else {
                for (let i = 0; i < this.infoData.allQuestion.length; i++) {
                    if (this.infoData.allQuestion[i].questionType === '02') {
                        this.form._01.push(this.infoData.allQuestion[i].answer.split(','))
                    } else {
                        this.form._01.push(this.infoData.allQuestion[i].answer)
                    }
                }
            }
        } else if (this.type === '05') {
            if (this.doFlag === '0') {
                for (let i = 0; i < this.infoData.allQuestion.length; i++) {
                    this.form._05.push([])
                    for (let j = 0; j < this.infoData.teaInfo.length; j++) {
                        this.form._05[i].push('')
                    }
                }
            } else {
                for (let i = 0; i < this.infoData.allQuestion.length; i++) {
                    this.form._05.push([])
                    let t = this.infoData.allQuestion[i].answer.split("@");
                    for (let j = 0; j < t.length; j++) {
                        this.form._05[i].push(t[j])
                    }
                }
            }
        }

        if (this.flag === true && this.type === '01') {
            this.$nextTick(() => {
                this.divHeight = document.getElementById("formDiv").offsetHeight;
            });
        }
    },
    methods: {
        //清空答案
        clear() {
            if (this.type === '01') {
                for (let i = 0; i < this.infoData.allQuestion.length; i++) {
                    if (this.infoData.allQuestion[i].questionType === '02') {
                        this.form._01[i] = []
                    } else {
                        this.form._01[i] = ''
                    }
                }
            }

            if (this.type === '05') {
                for (let i = 0; i < this.form._05.length; i++) {
                    for (let j = 0; j < this.form._05[i].length; j++) {
                        this.form._05[i][j] = ''
                    }
                }
            }

            this.key++;
        },
        //提交问卷
        submit() {
            confirmMsg('当前问卷已提交' + this.infoData.answerTime + '次,共可提交' + this.infoData.quesAnswerTime + '次,是否确定提交问卷？').then(() => {

                for (let i = 0; i < this.infoData.repetition.length; i++) {
                    let arr = []

                    for (let j = 0; j < this.infoData.teaInfo.length; j++) {
                        if (this.infoData.teaInfo[j].courseCode == this.infoData.repetition[i]) {
                            arr.push(j)
                        }
                    }
                    let str = "";
                    arr.forEach(item => {
                        str += item + ":";
                        for (let j = 0; j < this.form._05.length; j++) {
                            str += this.form._05[j][item]
                        }
                        str += "@"
                    })
                    str = str.slice(0, -1);
                    let split = str.split("@");
                    let flag = false
                    let tempIndex = 0
                    for (let j = 0; j < split.length; j++) {
                       let split2 = split[j].split(":");
                        if(split2[1].length == this.form._05.length){
                            flag = true
                            tempIndex = j
                            break
                        }
                    }
                    if(flag){
                        for (let j = 0; j < split.length; j++) {
                            if(tempIndex != j){
                                let split2 = split[j].split(":");
                                if(split2[1].length == 0){
                                    this.form._05.forEach(item=>{
                                        item[split2[0]] = " "
                                    })
                                }
                            }
                        }
                    }
                }

                this.$refs.form.validate((valid) => {
                    if (valid) {

                        this.showLoadingMask("提交中,请稍后...");

                        let answer = '';
                        if (this.type === '01') {
                            for (let i = 0; i < this.infoData.allQuestion.length; i++) {
                                answer += this.infoData.allQuestion[i].questionId + '@@@' + this.form._01[i] + '&&&'
                            }
                        }

                        if (this.type === '05') {
                            for (let i = 0; i < this.form._05.length; i++) {
                                for (let j = 0; j < this.infoData.teaInfo.length; j++) {
                                    answer += this.infoData.allQuestion[i].questionId + '@@@';
                                    answer += this.infoData.teaInfo[j].teaCode + ':::' + this.infoData.teaInfo[j].teaName + '///'
                                    answer += this.form._05[i][j]
                                    answer += '###'
                                }
                            }
                        }

                        let formData = new FormData();
                        formData.append('id', this.infoData.basic.id);
                        formData.append('type', this.type);
                        formData.append('userCode', this.userCode);
                        formData.append('answer', answer);

                        this.$api.evaluateManage.questionnaireSurvey.submit({
                            data: formData
                        }).then((res) => {
                            let state = res.data.data;
                            switch (state) {
                                case 'Success':
                                    location.reload();
                                    break;
                                default:
                                    showNotify('错误', '提交失败', 'error', 3000);
                                    break;
                            }
                        }).catch((err) => {
                            console.log(err);
                        });

                        this.closeLoadingMask();

                    } else {
                        this.alertMsg('请完成所有题目后重新提交');
                        return false;
                    }
                });

            });


        },
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        /**关闭loading**/
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
        alertMsg(str) {
            this.$message({
                message: str,
                type: 'warning'
            });
        },
    }
};
</script>

<style scoped>
.container {
    margin: 0 auto;
    width: 98%;
    height: 590px;
    overflow: auto;
    border: 1px solid #000000;
    border-collapse: collapse;
    overflow-x: auto;
    overflow-y: scroll;
}

.contentTable {
    width: 100%;
    text-align: center;
}

.contentTd {
    border-right: 1px solid #000000;
    border-bottom: 1px solid #000000;
}

.contentTr_3 {
    height: 30px;
    line-height: 18px;
}

.contentTitle {
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// info.vue?2acfc462